













































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'voucherTable'
})
export default class VoucherTable extends Vue {
  @Prop({ default: {} }) public voucherTableDetail: any
}
